<template>
  <div>
    <div class="ticket-description">
      <div
        v-for="(item, key) in info"
        :key="key"
        class="ticket-description__property"
      >
        <strong class="ticket-description__property__title">
          {{ `${getTitle(item)}:` }}
        </strong>

        <template v-if="item.type === 'phone'">
          <a
            class="ticket-description__property__phone"
            :href="`tel:${item.value}`"
          >
            {{ getPhoneNumber(item.value) }}
          </a>
        </template>

        <template v-else>
          {{ item.value }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import parsePhoneNumberFromString from 'libphonenumber-js';

export default {
  name: 'TicketFullDescription',
  props: {
    info: { type: Object, default: () => ({}) },
  },
  methods: {
    getTitle(item) {
      return (
        item.title[this.$store.activeLanguage] ||
        Object.values(item.title).find((val) => val)
      );
    },
    getPhoneNumber(value) {
      const parsedPhoneNumber = parsePhoneNumberFromString(value);
      return parsedPhoneNumber
        ? parsedPhoneNumber.formatInternational()
        : value;
    },
  },
};
</script>

<style lang="scss" scoped>
.ticket-description {
  margin-bottom: 10px;

  &__property {
    margin: 5px 0;
    user-select: text !important;

    &__title {
      margin-right: 5px;
    }

    &__phone {
      text-decoration: none;
    }
  }
}
</style>
